module.exports = __webpack_public_path__ + "img/banner-long.227e4ae5.jpg";